import React, { useEffect, useState } from "react";
import { Form, InputNumber } from "antd";

function Decimal({
  form,
  textColor,
  name,
  min,
  max,
  controlHeight = 40,
  label,
  width,
  required,
  errorMessage,
  validateFunction,
  labelCol,
  defaultValue,
  placeholder,
  disabled,
  onChange,
}) {
  const [minMaxStatus, setMinMaxStatus] = useState("");
  const [minMaxError, setMinMaxError] = useState("");

  useEffect(() => {
    form.setFieldsValue({ [name]: defaultValue });
    if (defaultValue?.toString()) {
      handleValueChange(defaultValue);
    }
  }, []);

  const handleValueChange = (value) => {
    let status = "";
    let msg = "";

    // If field is empty and required, clear min/max errors to show required validation
    if ((value === null || value === undefined || value === "") && required) {
      setMinMaxStatus("");
      setMinMaxError("");
      if (onChange) onChange(value);
      return;
    }

    if (min?.val?.toString() && value < min?.val) {
      status = "error";
      msg = min?.errorMessage;
    } else if (max?.val?.toString() && value > max?.val) {
      status = "error";
      msg = max?.errorMessage;
    }

    setMinMaxStatus(status);
    setMinMaxError(msg);
    if (onChange) onChange(value);
  };

  return (
    <Form.Item
      name={name}
      label={label}
      labelCol={{ span: labelCol ? labelCol : 8 }}
      style={{ width: width, fontWeight: 600 }}
      {...(minMaxStatus && { validateStatus: minMaxStatus, help: minMaxError || undefined })}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
      ]}
    >
      <InputNumber
        disabled={disabled}
        onChange={handleValueChange}
        step={0.1}
        style={{ width: "100%", backgroundColor: "#fff", fontWeight: 600, height: controlHeight, color: textColor }}
        placeholder={placeholder}
      />
    </Form.Item>
  );
}

export default Decimal;